import React, {useContext, useEffect, useState} from "react";
import {faCog, faGlobe} from "@fortawesome/pro-light-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChartLine, faHouse} from "@fortawesome/pro-solid-svg-icons";
import {CardActionArea} from "@material-ui/core";
import {BASE_URL} from '../../env.json';
import {AppContext} from "../../App";
import {faMedal, faSignOut} from "@fortawesome/pro-regular-svg-icons";
import {IconProp} from "@fortawesome/fontawesome-svg-core";
import {AppService} from "../../services/app.service";

function BottomNav() {
    const context = useContext(AppContext);

    // console.log(dayjs().subtract((dayjs().utcOffset()), 'm'));
    const[userIsAP, setUserIsAP] = useState<boolean>(false);

    useEffect(()=>{
        async function checkIfUserIsAnAP(){
            let appService = new AppService();
            const apCheck = await appService.checkIfUserIsAP();
            // console.log('AP Check response', apCheck.data.payload.data.user_is_ap);
            let userIsAP: boolean = false;
            userIsAP = !!apCheck.data.payload.data.user_is_ap;
            setUserIsAP(userIsAP)

            console.log("AP CHECK ", userIsAP)
        }
        checkIfUserIsAnAP();
    },[])

    if(context.deviceId === undefined)
    {
        return (
            <div className={'bottom-nav-non-ea'}>
                <CardActionArea className={'bottom-item'} >
                    <a href={BASE_URL + "userprofile/v4/summary/" + context.deviceId}>
                        <FontAwesomeIcon className={'icon'} icon={faHouse as IconProp} />
                        <span>HOME</span>
                    </a>
                </CardActionArea>

                <CardActionArea className={'bottom-item'}>
                    <a href={BASE_URL + "ascend/logout/"}>
                        <FontAwesomeIcon className={'icon'} icon={faSignOut as IconProp}/>
                        <span>LOGOUT</span>
                    </a>
                </CardActionArea>
            </div>
        )
    }
    else {
        return (

            <div className={'bottom-nav'}>
                <CardActionArea className={'bottom-item'} >
                    <a href={BASE_URL + "userprofile/v4/summary/" + context.deviceId}>
                        <FontAwesomeIcon className={'icon'} icon={faHouse as IconProp} />
                        <span>HOME</span>
                    </a>
                </CardActionArea>

                {(userIsAP) ? (<CardActionArea className={'bottom-item'} >
                        <a href={BASE_URL + `monitor/report-summary/${context.userId}/${context.deviceId}/`}>
                            <FontAwesomeIcon className={'icon'} icon={faGlobe as IconProp} />
                            <span>REPORTS</span>
                        </a>
                    </CardActionArea>
                ): ``}

                <CardActionArea className={'bottom-item'}>
                    <a href={'#'}>
                        <FontAwesomeIcon className={'icon-active'} icon={faChartLine as IconProp} />
                        <span>RECOVERY</span>
                    </a>
                </CardActionArea>

                <CardActionArea className={'bottom-item'}>
                    <a href={BASE_URL + "userprofile/view-badges/" + context.deviceId}>
                        <FontAwesomeIcon className={'icon'} icon={faMedal as IconProp} />
                        <span>BADGES</span>
                    </a>
                </CardActionArea>


                <CardActionArea className={'bottom-item'}>
                    <a href={BASE_URL + "userprofile/device-settings/" + context.deviceId}>
                        <FontAwesomeIcon className={'icon'} icon={faCog as IconProp}/>
                        <span>SETTINGS</span>
                    </a>
                </CardActionArea>

            </div>
        )
    }

}

export default BottomNav;